import store from "../storeConfig";

import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import getEnvVars from "../../enviroment";
import { Auth } from "aws-amplify";

const baseURL = getEnvVars().apiUrl;

// export function loadGenericNotification(message) {
//     store.dispatch({
//         type: "LOAD_GENERIC_NOTIFICATION",
//         newMessage: message
//     })
// }

export function setUnreadNotificationFlag() {
    store.dispatch({
        type: "SET_UNREAD_NOTIFICATIONS"
    })
}

export function setReadNotificationFlag() {
    store.dispatch({
        type: "SET_READ_NOTIFICATIONS"
    })
}

export function addNewNotification(notification) { 
    store.dispatch({
        type: "PUSH_NOTIFICATION",
        newNotification: notification
    })
}

export function dismissNotification(notificationId) {
    store.dispatch({
        type: "DISMISS_NOTIFICATION",
        notificationId: notificationId
    })
}

export function checkAndSetFUMNotification() {
    return;
    // removed FUM notification
}

export function loadNotificationsFromAPI(){
    // return; // safety return
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        axi.get('notifications').then( (result) => {
            store.dispatch({
                type: "SET_REMOTE_READ"
            })
            result.data.map((notif, index) => {
                notif.dismissed = false;
                addNewNotification(notif);
            })
            // foreach in result.data.notifications
            //      addNewNotification(notification)
        });
    });
}